import { LoginPageStore } from "./LoginPageStore";
import { UserStore } from "./UserStore";
import { StudentStore } from "./StudentStore";
import { VideoQueueStore } from "./VideoQueueStore";
import { PasswordResetPageStore } from "./PasswordResetPageStore";
import { ContactPageStore } from "./ContactPageStore";
import { OrganizationContentStore } from "./OrganizationContentStore";
import { LivestreamStore } from "./LivestreamStore";

export const loginPageStore = new LoginPageStore();
export const userStore = new UserStore();
export const studentStore = new StudentStore();
export const videoQueueStore = new VideoQueueStore();
export const passwordResetPageStore = new PasswordResetPageStore();
export const contactPageStore = new ContactPageStore();
export const organizationContentStore = new OrganizationContentStore();
export const livestreamStore = new LivestreamStore();
